module.exports = __webpack_public_path__ + "img/25.e469a2d4.png";